var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShareExternalLink1Fill = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2501 6.96394e-07H15.2501C15.1011 -0.000203605 14.9556 0.0445486 14.8325 0.128404C14.7094 0.21226 14.6144 0.331316 14.5601 0.470001C14.5032 0.605632 14.4881 0.75512 14.5166 0.89939C14.5451 1.04366 14.6159 1.17617 14.7201 1.28L18.0001 4.51L8.55007 13.81C8.36382 13.9974 8.25928 14.2508 8.25928 14.515C8.25928 14.7792 8.36382 15.0326 8.55007 15.22C8.64268 15.3145 8.75313 15.3897 8.875 15.4412C8.99688 15.4927 9.12776 15.5195 9.26007 15.52C9.521 15.5216 9.7722 15.4211 9.96007 15.24L19.4401 5.91L22.7301 9.15C22.7993 9.22011 22.8819 9.27569 22.9729 9.31347C23.0639 9.35125 23.1615 9.37047 23.2601 9.37C23.3598 9.37031 23.4586 9.34988 23.5501 9.31C23.685 9.25253 23.7998 9.15626 23.88 9.03341C23.9601 8.91055 24.0019 8.76666 24.0001 8.62V0.750001C23.9975 0.551894 23.9176 0.362629 23.7775 0.222535C23.6374 0.0824398 23.4482 0.00259066 23.2501 6.96394e-07Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 10.62C18.2348 10.62 17.9804 10.7254 17.7929 10.9129C17.6054 11.1004 17.5 11.3548 17.5 11.62V22H2V6.5H12.37C12.6352 6.5 12.8896 6.39464 13.0771 6.20711C13.2646 6.01957 13.37 5.76522 13.37 5.5C13.37 5.23478 13.2646 4.98043 13.0771 4.79289C12.8896 4.60536 12.6352 4.5 12.37 4.5H1.87C1.37405 4.5 0.898403 4.69702 0.54771 5.04771C0.197017 5.3984 1.88393e-10 5.87405 1.88392e-10 6.37L1.88393e-10 22.12C-7.02905e-06 22.6169 0.196691 23.0936 0.547099 23.4458C0.897508 23.7981 1.37313 23.9974 1.87 24H17.62C18.1186 24 18.5968 23.8019 18.9494 23.4494C19.3019 23.0968 19.5 22.6186 19.5 22.12V11.62C19.5 11.3548 19.3946 11.1004 19.2071 10.9129C19.0196 10.7254 18.7652 10.62 18.5 10.62Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShareExternalLink1Fill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/share-external-link-1_fill.f8d379b233251ce53713a9487e21def7.svg";